"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.variableReplacement = function (template, variables) {
  var regex = new RegExp("\\$\\d", "g");
  if (template === null) return "";
  return template.replace(regex, function (match) {
    var index = parseInt(match.substr(1), 10);
    var variable = variables[index - 1];
    return variable || "";
  });
};